export default __webpack_public_path__ + "c1d02b3d854e244f2d236c1e4e5407fa.png";